import { getAttributesWithoutPrefix } from 'tradera/features/discover/search';
import type {
    CategoryPageApiRequest,
    IndependentSearchApiRequest,
    SearchPageApiRequest
} from 'tradera/state/services/types/webapi-discover-generated';
import { getPriceRange } from './price-range';

type RequestTypes =
    | SearchPageApiRequest
    | CategoryPageApiRequest
    | IndependentSearchApiRequest;

export const createIndependentSearchApiRequest = (
    countryCodeIso2: string | undefined,
    automaticTranslationPreferred: boolean,
    locale: string | undefined,
    searchParams: { [key: string]: string }
): IndependentSearchApiRequest => {
    const request = createSearchPageApiRequest(
        countryCodeIso2,
        automaticTranslationPreferred,
        locale,
        searchParams
    );
    return {
        ...request,
        automaticTranslationPreferred:
            request.automaticTranslationPreferred || false,
        categoryId: request.categoryId || 0
    };
};

export const createCategoryPageApiRequest = (
    countryCodeIso2: string | undefined,
    automaticTranslationPreferred: boolean,
    locale: string | undefined,
    searchParams: { [key: string]: string }
): CategoryPageApiRequest => {
    const request = createSearchPageApiRequest(
        countryCodeIso2,
        automaticTranslationPreferred,
        locale,
        searchParams
    );
    return {
        ...request,
        automaticTranslationPreferred:
            request.automaticTranslationPreferred || false,
        categoryId: request.categoryId || 0
    };
};

export const createSearchPageApiRequest = (
    countryCodeIso2: string | undefined,
    automaticTranslationPreferred: boolean,
    locale: string | undefined,
    searchParams: { [key: string]: string }
): RequestTypes => ({
    shippingCountryCodeIso2: countryCodeIso2,
    languageCodeIso2: locale,
    automaticTranslationPreferred: automaticTranslationPreferred,
    allowedBuyerRegions: searchParams.allowedBuyerRegions,
    categoryId: searchParams.categoryId
        ? parseInt(searchParams.categoryId)
        : undefined,
    ...getPriceRange(searchParams),
    itemStatus: searchParams.itemStatus,
    itemType: searchParams.itemType,
    itemCondition: searchParams.itemCondition,
    sellerType: searchParams.sellerType,
    county: searchParams.county,
    sortBy: searchParams.sortBy,
    paging: searchParams.paging,
    attributes: getAttributesWithoutPrefix(searchParams),
    query: searchParams.q,
    queryScope: searchParams.queryScope,
    zipCode: searchParams.zipCode || searchParams.zipcode,
    fromNumberOfBids: searchParams.fromNumberOfBids
        ? parseInt(searchParams.fromNumberOfBids)
        : undefined,
    toNumberOfBids: searchParams.toNumberOfBids
        ? parseInt(searchParams.toNumberOfBids)
        : undefined,
    alias: searchParams.alias,
    searchInLongDescription: searchParams.searchInLongDescription
        ? searchParams.searchInLongDescription === 'true'
        : undefined,
    searchTypeVariantHint: searchParams.searchTypeVariantHint,
    shippingTypes:
        searchParams.shippingTypes !== undefined
            ? decodeURIComponent(searchParams.shippingTypes).split(';')
            : undefined
});
